export const environment = {
  production: true,
  api: 'https://aidorando-development-395612.appspot.com',
  localStorage: {
    language: 'aid_language'
  },
  appHost: 'https://aidorando-development-395612.firebaseapp.com'
};
